package br.com.texeratx.boardgametimeapp.core.spotify.storage

import kotlinx.browser.localStorage
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

class SpotifyStorageJs : SpotifyStorage {

    private companion object {
        const val KEY_EPHEMERAL = "spotify_ephemeral"
        const val KEY_TOKENS = "spotify_tokens"
    }

    private val json = Json { ignoreUnknownKeys = true }

    override fun saveEphemeral(value: SpotifyEphemeral) {
        localStorage.setItem(KEY_EPHEMERAL, json.encodeToString(value))
    }

    override fun readEphemeral(): SpotifyEphemeral? {
        val raw = localStorage.getItem(KEY_EPHEMERAL) ?: return null
        return runCatching { json.decodeFromString<SpotifyEphemeral>(raw) }.getOrNull()
    }

    override fun clearEphemeral() {
        localStorage.removeItem(KEY_EPHEMERAL)
    }

    override fun saveTokens(tokens: SpotifyTokens) {
        localStorage.setItem(KEY_TOKENS, json.encodeToString(tokens))
    }

    override fun readTokens(): SpotifyTokens? {
        val raw = localStorage.getItem(KEY_TOKENS) ?: return null
        return runCatching { json.decodeFromString<SpotifyTokens>(raw) }.getOrNull()
    }

    override fun clearTokens() {
        localStorage.removeItem(KEY_TOKENS)
    }
}